import { Languages } from "src/api/types";

export const isValidLanguage = (lang: unknown): lang is Languages =>
  lang === "en" || lang === "es" || lang === "pt";
